import { Component, inject } from '@angular/core';
import { OnInit } from '@angular/core';
import { Router, RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoginStatus } from './account/shared/login-status-service';
import { AutoLogoutService } from './account/shared/auto-logout.service';
import { environment } from '../environments/environment';
import { Subscription } from 'rxjs';
import { SharedService } from './shared/shared.service';
import { AppUpdatesService } from './app-updates/app-updates.service';
import { HubService } from './home/hub.service';
import { buildSsoUrl } from './account/shared/sso-url';

@Component({
  selector: 'audit-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, MatToolbarModule, MatIconModule, MatButtonModule, MatTooltipModule]
})
export class AppComponent implements OnInit {

  title = 'audit';
  loggedIn = false;
  fullName = '';
  orgName = '';
  currentYear = new Date().getFullYear();
  orgId = '';
  version = '';

  updateDate: Date | null = null;
  updateSubscription: Subscription;
  insightsAvailable = false;
  exportsAvailable = false;

  private _LoginStatus = inject(LoginStatus);
  private _Router = inject(Router);
  private _AutoLogout = inject(AutoLogoutService);
  private _SharedService = inject(SharedService);
  private _Updates = inject(AppUpdatesService);
  private _Hub = inject(HubService);

  constructor() {
    this.updateSubscription = this._Updates.updateCount$.subscribe(
      u => {
        this.updateDate = u;
      }
    );
  }

  ngOnInit(): void {

    if (environment.production) {
      window.console.log = () => { /* no-op: disable console logging in production */ };
    }

    this.currentYear = new Date().getFullYear();

    this._LoginStatus.loggedIn.subscribe((val) => {
      this.loggedIn = val;

      if (sessionStorage.getItem('userName')) {
        this.fullName = sessionStorage.getItem('firstName') + ' ' + sessionStorage.getItem('lastName');
        this.orgName = sessionStorage.getItem('orgName') || '';
      }

      if (this.loggedIn) {
        this._Updates.updateLastUpdateDate();

        this._Hub.getFeatureRestrictions().subscribe(restrictions => {
          sessionStorage.setItem('featureRestrictions', JSON.stringify(restrictions));
          const restriction = restrictions.find(item => item.id == "USER_MOVEMENTS");
          if (restriction) {
            this.insightsAvailable = restriction.allowed;
          }
          else {
            this.insightsAvailable = false;
          }

          // Point-in-time restore export — gradual rollout flag.
          const exportRestriction = restrictions.find(item => item.id == "PIT_EXPORT");
          this.exportsAvailable = exportRestriction ? exportRestriction.allowed : false;
        });
      }

    });

    this._SharedService.version$.subscribe(v => this.version = v);

  }

  openConfigTool(): void {
    // Pass tokens via URL fragment so the refresh token stays out of server logs.
    const accessToken = sessionStorage.getItem('accessToken');
    const refreshToken = sessionStorage.getItem('refreshToken');
    window.open(
      buildSsoUrl(environment.configAppUrl, accessToken, refreshToken),
      '_blank',
    );
  }

  logOut(): void {
    this._AutoLogout.destroy();
    this._LoginStatus.logout();
    this._Router.navigate(['/welcome'], { queryParams: { isLogout: 'true' } });
  }

}
